export default function WhatsAppFloat() {
  const whatsappNumber = '+96871989006';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Hello Cleaning Bees, I would like to inquire about your services.')}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-2xl hover:bg-green-600 transition-all duration-300 transform hover:scale-110 cursor-pointer group"
      aria-label="Contact us on WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl text-white"></i>
      <span className="absolute right-20 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Chat with us!
      </span>
    </a>
  );
}